export default __webpack_public_path__ + "underline-text-option.png";